module.exports = __webpack_public_path__ + "img/avatar.bd2a142a.jpg";